// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var PageUITitle = require("../../../components/PageTitle/PageUITitle.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayHeader_draft_graphql = require("../../../__generated__/PropertyWizardRelayHeader_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayHeader_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayHeader_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayHeader_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayHeader_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayHeader_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Header(props) {
  var match = PropertyWizardFormRelay.Context.use();
  var draft = use(props.draft);
  var streetAddress = Core__Option.getOr(draft.draftProperty.address, "your property");
  var tmp = match.mode;
  if (typeof tmp !== "object") {
    return JsxRuntime.jsx(PageUITitle.make, {
                title: "Broadcast your property to TAN members"
              });
  }
  switch (tmp.TAG) {
    case "Edit" :
        return JsxRuntime.jsx(PageUITitle.make, {
                    title: "You are editing " + streetAddress
                  });
    case "Rebroadcast" :
        return JsxRuntime.jsx(PageUITitle.make, {
                    title: "Rebroadcast " + (streetAddress + " to TAN members")
                  });
    case "BroadcastQuietSeller" :
        return JsxRuntime.jsx(PageUITitle.make, {
                    title: "Broadcast " + (streetAddress + " to TAN members")
                  });
    
  }
}

var make = PropertyWizardRelay__Header;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* PageUITitle Not a pure module */
